/**
 * Identyfikatory zakładek profilu (§7.3 wireframe PROFIL „Podsumowanie | Relacje | Oś czasu |
 * Dowody” + „Notatki badawcze i otwarte zadania”, §9, etap 7 warsztat badawczy) — WYDZIELONE z
 * `PersonProfileRoute.tsx` do osobnego, lekkiego modułu, bo `router.tsx` musi je znać dla
 * `validateSearch` trasy `/people/$id` (§6: identyfikatory w adresach są niejawne, ale STAN
 * ZAKŁADKI w query string jest jawny i musi być zwalidowany), a `PersonProfileRoute.tsx` jest
 * ładowany LENIWIE (`lazyRouteComponent`, §18.3) — statyczny import stamtąd w `router.tsx`
 * wciągnąłby całą zakładkę profilu (i jej zależności) do chunku powłoki.
 *
 * `research` (etap 7, ADR 0016, A13/§8.2 „warstwa badawcza nie może wyglądać jak fakt") dodana
 * jako WŁASNA, RÓWNORZĘDNA zakładka — nigdy sekcja wmieszana w `summary`/`relations` — dokładnie
 * po to, żeby oddzielenie materiału roboczego od danych potwierdzonych było STRUKTURALNE
 * (osobna zakładka), nie wyłącznie wizualne (patrz `features/research/PersonResearchSection.tsx`).
 */
export const PROFILE_TAB_IDS = [
  'summary',
  'relations',
  'timeline',
  'evidence',
  'research',
  // §9 wiersz „Historia": „chronologia zestawów zmian, kto, co, dlaczego, porównanie wersji".
  // Własna zakładka, nie sekcja w podsumowaniu — historia jest materiałem o TYM, jak dane
  // powstały, nie samą daną, więc jej wmieszanie zacierałoby tę różnicę.
  'history',
] as const;
export type ProfileTabId = (typeof PROFILE_TAB_IDS)[number];

export function isProfileTabId(value: unknown): value is ProfileTabId {
  return typeof value === 'string' && (PROFILE_TAB_IDS as readonly string[]).includes(value);
}
